import { useState, useRef, useEffect } from "react";
import styles from "./EmojiPicker.module.css";

const EMOJIS = {
  "Smileys": ["😀","😃","😄","😁","😆","😅","😂","🤣","😊","😇","🙂","🙃","😉","😌","😍","🥰","😘","😗","😙","😚","😋","😛","😝","😜","🤪","🤨","🧐","🤓","😎","🥸","🤩","🥳","😏","😒","😞","😔","😟","😕","🙁","☹️","😣","😖","😫","😩","🥺","😢","😭","😤","😠","😡"],
  "Gestures": ["👍","👎","👌","🤌","🤏","✌️","🤞","🤟","🤘","🤙","👈","👉","👆","🖕","👇","☝️","👋","🤚","🖐️","✋","🖖","👏","🙌","🤲","🤝","🙏","💪","🦾","🦿","🦵","🦶"],
  "Hearts": ["❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔","❣️","💕","💞","💓","💗","💖","💘","💝","💟","☮️","✝️","☯️","🕉️","🔯","♈"],
  "Nature": ["🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐨","🐯","🦁","🐮","🐷","🐸","🐵","🙈","🙉","🙊","🐔","🐧","🐦","🐤","🦆","🦅","🦉","🦇","🐺","🐗","🐴","🦄"],
  "Food": ["🍎","🍊","🍋","🍇","🍓","🫐","🍈","🍒","🍑","🥭","🍍","🥥","🥝","🍅","🍆","🥑","🥦","🥬","🥒","🌶️","🫑","🧄","🧅","🥔","🍠","🥐","🥯","🍞","🥖","🫓"],
  "Activities": ["⚽","🏀","🏈","⚾","🥎","🎾","🏐","🏉","🥏","🎱","🪀","🏓","🏸","🏒","🥊","🎯","🎮","🎲","🎭","🎨","🎬","🎤","🎧","🎼","🎹","🥁","🪘","🎷","🎺","🪗"],
  "Objects": ["💌","💣","🪓","🔪","🗡️","⚔️","🛡️","🪃","🏹","🪚","🔧","🪛","🔩","⚙️","🗜️","⚖️","🦯","🔗","⛓️","🪝","🧲","🪜","🧰","🪤","🧱","🪞","🚪","🛋️","🪑","🚽"],
  "Symbols": ["♻️","🔱","📛","🔰","⭕","✅","❎","🆗","🆙","🆒","🆕","🆓","0️⃣","1️⃣","2️⃣","3️⃣","4️⃣","5️⃣","6️⃣","7️⃣","8️⃣","9️⃣","🔟","🔠","🔡","🔢","🔣","🔤","🅰️","🅱️"],
};

const EmojiPicker = ({ onSelect, onClose, triggerRef }) => {
  const [activeCategory, setActiveCategory] = useState("Smileys");
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target) && !triggerRef?.current?.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  const filtered = search
    ? Object.values(EMOJIS).flat().filter(() => true).slice(0, 60)
    : EMOJIS[activeCategory];

  return (
    <div className={styles.picker} ref={ref}>
      <input
        type="text"
        className={styles.search}
        placeholder="Search emoji..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        autoFocus
      />
      {!search && (
        <div className={styles.categories}>
          {Object.keys(EMOJIS).map((cat) => (
            <button
              key={cat}
              className={`${styles.catBtn} ${activeCategory === cat ? styles.activeCat : ""}`}
              onClick={() => setActiveCategory(cat)}
              title={cat}
            >
              {EMOJIS[cat][0]}
            </button>
          ))}
        </div>
      )}
      <div className={styles.grid}>
        {filtered.map((emoji, i) => (
          <button
            key={i}
            className={styles.emoji}
            onClick={() => onSelect(emoji)}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmojiPicker;
